import React from 'react';

const Spinner = () => {
  // todo the inner div is used only for the css spinner loading
  return (
    <div className="lds-ripple">
      <div />
      <div />
    </div>
  );
};

export default Spinner;
